import { useTranslation } from "react-i18next";

//components
import { SplitButton } from "primereact/splitbutton";

import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CategoryIcon, TreeTableCard } from "./styled";

//utils
import handleLongText from "../../../../utils/handleLongText/handleLongText";
import { FaEllipsisH, FaFolderOpen } from "react-icons/fa";
import { DisciplineObjectTooltip } from "../../../../components/discipline-object-tooltip";
import { DefaultButton } from "../../../../components/copy-button/styles";
import { MediaTooltip } from "../../../../components/media-tooltip";
import { useEffect, useState } from "react";
import { getMediaCategoryList } from "../../../../services/media.service";
import { codeTemplate } from "../utils";

export function LinksTable(props: any) {
	const { t: translation } = useTranslation();
	const {
		nodes,
		treeFields,
		handleTableSort,
		sortField,
		sortOrder,
		handleViewLink,
		handleChangeStatusLink,
		handleDeleteLink,
		onExpand = null,
		expandedKeys = {},
	} = props;

	const [categoryList, setCategoryList] = useState([]);

	useEffect(() => {
		getMediaCategoryList().then((data) => setCategoryList(data));
	}, []);

	function nameTemplate(node: any) {
		let name = node.data.title;
		return (
			<>
				<span>{handleLongText(name, 32)}</span>
				{node.data.type === "Discipline" ||
				node.data.type === "Item" ||
				node.data.type === "Theme" ? (
					<DisciplineObjectTooltip
						node={node.data}
						category={categoryList}
					>
						<DefaultButton
							style={{ float: "right", marginTop: "0.2em" }}
							type="button"
							data-testid="copybtn"
						>
							<FaFolderOpen
								style={{
									color: `${
										node.data.is_active
											? "#606060"
											: "#CCCCCC"
									}`,
								}}
							/>
						</DefaultButton>
					</DisciplineObjectTooltip>
				) : (
					<></>
				)}
				{/* {(node.data.type === 'Item' || node.data.type === 'theme') ? <FaFolderOpen style={{ float: 'right', marginTop: '0.5em' }}></FaFolderOpen> : <></>} */}
				{node.data.type === "Media" ? (
					<MediaTooltip node={node}>
						<DefaultButton
							style={{ float: "right", marginTop: "0.2em" }}
							type="button"
							data-testid="copybtn"
						>
							<CategoryIcon
								style={{
									color: `${
										node.data.is_active
											? "#606060"
											: "#CCCCCC"
									}`,
								}}
								className={`material-icons-${node.data.category.category_icon}`}
							>
								{node.data.category.category_icon.split(" ")[1]}
							</CategoryIcon>
						</DefaultButton>
					</MediaTooltip>
				) : (
					<></>
				)}
			</>
		);
	}

	function typeTemplate(node: any) {
		let typeMaterial = "node.data.title";

		switch (node.data.type) {
			case "Discipline":
				typeMaterial = "Disciplina";
				break;
			case "Item":
				typeMaterial = "Unidade";
				break;
			case "Theme":
				typeMaterial = "Tema";
				break;
			case "Media":
				typeMaterial = "Objeto";
				break;
		}

		return <span>{typeMaterial}</span>;
	}

	function knowledgesTemplate(node: any) {
		return (
			<>
				{node?.data.knowledge_area?.length ? (
					node?.data.knowledge_area?.map(
						(knowledge: any, index: number) => (
							<>
								{knowledge +
									(node?.data.knowledge_area?.length > 1
										? node?.data.knowledge_area?.length ===
										  index + 1
											? " "
											: ", "
										: " ")}
							</>
						)
					)
				) : (
					<></>
				)}
			</>
		);
	}

	function actionsTemplate(node: any) {
		let items: any = [];

		if (node.data.is_active) {
			items.push({
				label: translation("manager.links.toView"),
				command: () => {
					handleViewLink(node);
				},
			});
			items.push({
				label: translation("manager.links.inactivate"),
				command: () => {
					handleChangeStatusLink(node);
				},
			});
		} else {
			items.push({
				label: translation("manager.links.reactivate"),
				command: () => {
					handleChangeStatusLink(node);
				},
			});
			items.push({
				label: translation("manager.links.remove"),
				command: () => {
					handleDeleteLink(node);
				},
			});
		}

		return (
			<OverlayTrigger placement="top" overlay={<Tooltip>Opções</Tooltip>}>
				<div>
					<SplitButton
						label=""
						className="p-button p-component p-button-rounded p-button-text p-button-icon-only"
						buttonClassName="d-none"
						dropdownIcon={<FaEllipsisH />}
						model={items}
					/>
				</div>
			</OverlayTrigger>
		);
	}

	function rowClassName(node: any) {
		return {
			"p-inactivate": !node.data.is_active,
			"p-discipline": node.data.type === "Discipline",
			"p-theme": node.data.type === "Theme",
			"p-item": node.data.type === "Item",
			"p-media": node.data.type === "Media",
		};
	}

	return (
		<div>
			<TreeTableCard>
				<TreeTable
					autoLayout
					value={nodes}
					rowClassName={rowClassName}
					sortField={sortField}
					sortOrder={sortOrder}
					onSort={(e) => handleTableSort(e)}
					onExpand={onExpand}
					expandedKeys={expandedKeys}
				>
					{!!treeFields?.length &&
						treeFields?.map((col: any) => {
							if (col.actionsTemplate) {
								return (
									<Column
										key={col.field}
										body={actionsTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.nameTemplate) {
								return (
									<Column
										expander
										key={col.field}
										body={nameTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.codeTemplate) {
								return (
									<Column
										key={col.field}
										body={codeTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.knowledgesTemplate) {
								return (
									<Column
										key={col.field}
										body={knowledgesTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.typeTemplate) {
								return (
									<Column
										key={col.field}
										body={typeTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else {
								return (
									<Column
										key={col.field}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							}
						})}
					{props.children}
				</TreeTable>
			</TreeTableCard>
		</div>
	);
}
